import { jsxs as _, jsx as s, Fragment as I } from "react/jsx-runtime";
import * as u from "react";
import { forwardRef as L } from "react";
import "react-dom";
function H(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var h = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var $;
function T() {
  return $ || ($ = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          o && (r = l(r, a.call(this, o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var o in r)
          i.call(r, o) && r[o] && (e = l(e, this && this[o] || o));
        return e;
      }
      function l(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(h)), h.exports;
}
var k = T();
const G = /* @__PURE__ */ H(k), J = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, K = G.bind(J), w = "purpur-icon", Q = "md", U = (t) => t.filter((i) => Object.keys(i).length >= 1).map((i) => `${i.name}="${i.value}"`).join(" "), X = ({ content: t = "", title: i } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    i ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = i ? `<title>${i}</title>` : "";
  return `<svg ${U(n)}>${a}${t}</svg>`;
}, Y = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), V = ({
  ["data-testid"]: t,
  svg: i,
  allyTitle: n,
  className: a,
  size: l = Q,
  ...r
}) => {
  const e = X({
    content: Y(i.svg),
    title: n
  }), o = K(a, w, `${w}--${l}`);
  return /* @__PURE__ */ s(
    "span",
    {
      className: o,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
V.displayName = "Icon";
const rr = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function tr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var S = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var j;
function er() {
  return j || (j = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          o && (r = l(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var o in r)
          i.call(r, o) && r[o] && (e = l(e, o));
        return e;
      }
      function l(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(S)), S.exports;
}
var nr = er();
const ar = /* @__PURE__ */ tr(nr), N = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, O = "purpur-field-error-text", ir = ({
  children: t,
  className: i,
  ["aria-relevant"]: n = "additions text",
  ...a
}) => /* @__PURE__ */ _(
  "div",
  {
    className: ar([i, N[O]]),
    "aria-live": "assertive",
    "aria-relevant": n,
    ...a,
    children: [
      /* @__PURE__ */ s(V, { svg: rr, size: "xs", className: N[`${O}__icon`] }),
      t
    ]
  }
);
function lr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var A = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var C;
function or() {
  return C || (C = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          o && (r = l(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var o in r)
          i.call(r, o) && r[o] && (e = l(e, o));
        return e;
      }
      function l(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(A)), A.exports;
}
var ur = or();
const sr = /* @__PURE__ */ lr(ur), P = {
  "purpur-field-helper-text": "_purpur-field-helper-text_atw6b_1",
  "purpur-field-helper-text--disabled": "_purpur-field-helper-text--disabled_atw6b_9"
}, q = "purpur-field-helper-text", pr = ({
  children: t,
  className: i,
  disabled: n,
  id: a,
  ...l
}) => {
  const r = sr([
    i,
    P[q],
    {
      [P[`${q}--disabled`]]: n
    }
  ]);
  return /* @__PURE__ */ s("span", { id: a, className: r, ...l, children: t });
};
function M(t, i) {
  if (typeof t == "function")
    return t(i);
  t != null && (t.current = i);
}
function cr(...t) {
  return (i) => {
    let n = !1;
    const a = t.map((l) => {
      const r = M(l, i);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let l = 0; l < a.length; l++) {
          const r = a[l];
          typeof r == "function" ? r() : M(t[l], null);
        }
      };
  };
}
var Z = u.forwardRef((t, i) => {
  const { children: n, ...a } = t, l = u.Children.toArray(n), r = l.find(fr);
  if (r) {
    const e = r.props.children, o = l.map((p) => p === r ? u.Children.count(e) > 1 ? u.Children.only(null) : u.isValidElement(e) ? e.props.children : null : p);
    return /* @__PURE__ */ s(g, { ...a, ref: i, children: u.isValidElement(e) ? u.cloneElement(e, void 0, o) : null });
  }
  return /* @__PURE__ */ s(g, { ...a, ref: i, children: n });
});
Z.displayName = "Slot";
var g = u.forwardRef((t, i) => {
  const { children: n, ...a } = t;
  if (u.isValidElement(n)) {
    const l = mr(n), r = _r(a, n.props);
    return n.type !== u.Fragment && (r.ref = i ? cr(i, l) : l), u.cloneElement(n, r);
  }
  return u.Children.count(n) > 1 ? u.Children.only(null) : null;
});
g.displayName = "SlotClone";
var dr = ({ children: t }) => /* @__PURE__ */ s(I, { children: t });
function fr(t) {
  return u.isValidElement(t) && t.type === dr;
}
function _r(t, i) {
  const n = { ...i };
  for (const a in i) {
    const l = t[a], r = i[a];
    /^on[A-Z]/.test(a) ? l && r ? n[a] = (...e) => {
      r(...e), l(...e);
    } : l && (n[a] = l) : a === "style" ? n[a] = { ...l, ...r } : a === "className" && (n[a] = [l, r].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function mr(t) {
  var i, n;
  let a = (i = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : i.get, l = a && "isReactWarning" in a && a.isReactWarning;
  return l ? t.ref : (a = (n = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : n.get, l = a && "isReactWarning" in a && a.isReactWarning, l ? t.props.ref : t.props.ref || t.ref);
}
var vr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], xr = vr.reduce((t, i) => {
  const n = u.forwardRef((a, l) => {
    const { asChild: r, ...e } = a, o = r ? Z : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(o, { ...e, ref: l });
  });
  return n.displayName = `Primitive.${i}`, { ...t, [i]: n };
}, {}), yr = "Label", F = u.forwardRef((t, i) => /* @__PURE__ */ s(
  xr.label,
  {
    ...t,
    ref: i,
    onMouseDown: (n) => {
      var a;
      n.target.closest("button, input, select, textarea") || ((a = t.onMouseDown) == null || a.call(t, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
F.displayName = yr;
var br = F;
function gr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var R = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var E;
function hr() {
  return E || (E = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          o && (r = l(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var o in r)
          i.call(r, o) && r[o] && (e = l(e, o));
        return e;
      }
      function l(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(R)), R.exports;
}
var $r = hr();
const wr = /* @__PURE__ */ gr($r), v = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, x = "purpur-label", Sr = ({
  children: t,
  className: i,
  disabled: n,
  negative: a = !1,
  ...l
}) => {
  const r = wr([
    i,
    v[x],
    {
      [v[`${x}--disabled`]]: n,
      [v[`${x}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ s(br, { className: r, ...l, children: t });
};
function jr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var y = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var D;
function Nr() {
  return D || (D = 1, function(t) {
    (function() {
      var i = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          o && (r = l(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var o in r)
          i.call(r, o) && r[o] && (e = l(e, o));
        return e;
      }
      function l(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(y)), y.exports;
}
var Or = Nr();
const b = /* @__PURE__ */ jr(Or), c = {
  "purpur-text-area": "_purpur-text-area_15b4m_1",
  "purpur-text-area__label": "_purpur-text-area__label_15b4m_8",
  "purpur-text-area__label-text": "_purpur-text-area__label-text_15b4m_13",
  "purpur-text-area__frame": "_purpur-text-area__frame_15b4m_16",
  "purpur-text-area__textarea-container": "_purpur-text-area__textarea-container_15b4m_23",
  "purpur-text-area__textarea-container--disabled": "_purpur-text-area__textarea-container--disabled_15b4m_33",
  "purpur-text-area__textarea-container--readonly": "_purpur-text-area__textarea-container--readonly_15b4m_36",
  "purpur-text-area__textarea": "_purpur-text-area__textarea_15b4m_23",
  "purpur-text-area__textarea--valid": "_purpur-text-area__textarea--valid_15b4m_82",
  "purpur-text-area__textarea--error": "_purpur-text-area__textarea--error_15b4m_82"
}, d = "purpur-text-area", Ar = ({
  id: t,
  ["data-testid"]: i,
  className: n,
  errorText: a,
  helperText: l,
  label: r,
  rows: e = 3,
  cols: o = 90,
  ...p
}, W) => {
  const f = (z) => i ? `${i}-${z}` : void 0, m = l ? `${t}-helper-text` : void 0, B = b([
    c[`${d}__textarea-container`],
    {
      [c[`${d}__textarea-container--disabled`]]: p.disabled,
      [c[`${d}__textarea-container--readonly`]]: p.readOnly && !p.disabled
    }
  ]);
  return /* @__PURE__ */ _("div", { className: b(n, c[d]), "data-testid": i, children: [
    r && /* @__PURE__ */ _(
      Sr,
      {
        htmlFor: t,
        disabled: p.disabled,
        className: c[`${d}__label`],
        "data-testid": f("label"),
        children: [
          p.required && /* @__PURE__ */ s("span", { "aria-hidden": !0, children: "*" }),
          r
        ]
      }
    ),
    /* @__PURE__ */ _("div", { className: B, children: [
      /* @__PURE__ */ s(
        "textarea",
        {
          ...p,
          ref: W,
          id: t,
          "data-testid": f("textarea"),
          "aria-describedby": p["aria-describedby"] || m,
          "aria-invalid": p["aria-invalid"] || !!a,
          className: b([
            c[`${d}__textarea`],
            {
              [c[`${d}__textarea--error`]]: !!a
            }
          ]),
          rows: e,
          cols: o
        }
      ),
      /* @__PURE__ */ s("div", { className: c[`${d}__frame`] })
    ] }),
    m && /* @__PURE__ */ s(pr, { "data-testid": f("helper-text"), id: m, children: l }),
    a && /* @__PURE__ */ s(ir, { "data-testid": f("error-text"), children: a })
  ] });
}, Cr = L(Ar);
Cr.displayName = "TextArea";
export {
  Cr as TextArea
};
//# sourceMappingURL=text-area.es.js.map
